import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/personalScript',
    component: HeaderAsideLayout,
    children: [
      //首页
      { path: '/personalScript', component: () => import('@/pages/scriptLibrary/script/index.vue') },
    ],
  },
  {
    path: '/shortPlay',
    component: HeaderAsideLayout,
    children: [
      //短剧
      { path: '/shortPlay', component: () => import('@/pages/scriptLibrary/shortPlay/index.vue') },
      { path: '/shortPlay/detail', component: () => import('@/pages/scriptLibrary/shortPlay/detail.vue') },
    ],
  }
]
export default list